
import React from 'react';

const ForkliftUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M24.5 22V5h-2v11h-1.36L16.22 5.33A4.05 4.05 0 0012.57 3H8.5c-1.65 0-3 1.35-3 3v8c-1.1 0-2 .9-2 2v3h2v-3h4v1c0 .55.45 1 1 1h12v5c0 .55.45 1 1 1h5v-2h-4zm-13-6v-1c0-.55-.45-1-1-1h-3V6c0-.55.45-1 1-1h4.07c.78 0 1.5.46 1.83 1.17L18.94 16H11.5z'
			></path>
			<path
				fill='#2d2d2d'
				d='M12.5 22.5c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5S7.07 26 9 26s3.5-1.57 3.5-3.5zm-5 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.83 24 9 24s-1.5-.67-1.5-1.5zM21.5 22.5c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5S16.07 26 18 26s3.5-1.57 3.5-3.5zm-5 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S18.83 24 18 24s-1.5-.67-1.5-1.5zM26.5 30h-21v2h21v-2z'
			></path>
		</svg>
	);
};

export default ForkliftUnderline;

